var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wl-study-ceter-main-wrapper"},[_c('div',{staticClass:"head-banner-con",style:({backgroundImage: 'url(' + _vm.defaultCover + ')'})}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }